<div class="leasingModal">
    <div class="closeContainer">
        <mat-icon (click)="cancel()">close</mat-icon>
    </div>
    <h1 mat-dialog-title>Haluatko vaihtaa kuukausibudjettia?</h1>
    <div mat-dialog-content>
        <p>Jos valitset <strong>"Kyllä"</strong>, autojen tiedot nollaantuvat.<br />
            Jos haluat pitää kuukausibudjetin ennallaan, valitse <strong>"Peruuta"</strong>.</p>
    </div>
    <div mat-dialog-actions align="end">
        <button class="bordered button" (click)="cancel()">PERUUTA</button>
        <button class="orange button" (click)="ok()">KYLLÄ</button>
    </div>
</div>